(function (window, document) {
  "use strict";

  var registeredVideos = new WeakSet();
  var visibility = new Map();
  var videos = [];
  var mobileViewport = window.matchMedia("(max-width: 640px)");
  var coarsePointer = window.matchMedia("(hover: none) and (pointer: coarse)");
  var reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
  var connection = window.navigator && (
    window.navigator.connection ||
    window.navigator.mozConnection ||
    window.navigator.webkitConnection
  );
  var videoObserver = null;

  function constrainedPlayback() {
    // respeta siempre reduced-motion y saveData
    if (reducedMotion.matches || Boolean(connection && connection.saveData)) {
      return true;
    }
    return mobileViewport.matches || coarsePointer.matches;
  }

  // Home grid (data-video-eager): autoplay también en mobile;
  // solo se bloquea por reduced-motion / saveData.
  function constrainedPlaybackFor(video) {
    if (reducedMotion.matches || Boolean(connection && connection.saveData)) {
      return true;
    }
    if (video.hasAttribute("data-video-eager")) return false;
    return mobileViewport.matches || coarsePointer.matches;
  }

  function syncVideos() {
    var target = null;
    var targetRatio = 0;

    videos = videos.filter(function (video) {
      if (video.isConnected) return true;
      video.pause();
      if (video.getAttribute("src")) {
        video.removeAttribute("src");
        video.load();
      }
      visibility.delete(video);
      registeredVideos.delete(video);
      if (window.MarlotVideoPlaybackCoordinator) {
        window.MarlotVideoPlaybackCoordinator.unregister(video);
      }
      if (videoObserver) videoObserver.unobserve(video);
      return false;
    });

    if (!document.hidden) {
      visibility.forEach(function (ratio, video) {
        if (constrainedPlaybackFor(video)) return;
        if (ratio >= 0.35 && ratio > targetRatio) {
          target = video;
          targetRatio = ratio;
        }
      });
    }

    videos.forEach(function (video) {
      if (video !== target) {
        video.pause();
        var eager = video.hasAttribute("data-video-eager");
        if (!eager && (visibility.get(video) || 0) === 0 && video.getAttribute("src")) {
          video.removeAttribute("src");
          video.load();
        }
        return;
      }

      if (!window.MarlotVideoPlaybackCoordinator) {
        video.pause();
        if (video.getAttribute("src")) {
          video.removeAttribute("src");
          video.load();
        }
        return;
      }
      if (!video.getAttribute("src") && video.dataset.videoSrc) {
        video.setAttribute("src", video.dataset.videoSrc);
        video.load();
      }
      if (video.paused) {
        window.MarlotVideoPlaybackCoordinator.requestPlay(video);
      }
    });
  }

  function registerVideos(root) {
    var candidates = [];
    if (root.nodeType === 1 && root.matches("video.video-featured[data-video-src]")) {
      candidates.push(root);
    }
    if (typeof root.querySelectorAll === "function") {
      candidates = candidates.concat(Array.prototype.slice.call(
        root.querySelectorAll("video.video-featured[data-video-src]")
      ));
    }

    candidates.forEach(function (video) {
      if (registeredVideos.has(video)) return;
      registeredVideos.add(video);
      videos.push(video);
      video.autoplay = false;
      video.removeAttribute("autoplay");
      var eager = video.hasAttribute("data-video-eager");
      if (eager) {
        // Home grid: carga inmediata (primer frame listo sin scroll)
        video.preload = "metadata";
        video.setAttribute("preload", "metadata");
        if (!video.getAttribute("src") && video.dataset.videoSrc) {
          video.setAttribute("src", video.dataset.videoSrc);
        }
      } else {
        video.preload = "none";
        video.setAttribute("preload", "none");
      }
      video.playsInline = true;
      video.muted = true;
      video.pause();
      if (window.MarlotVideoPlaybackCoordinator) {
        window.MarlotVideoPlaybackCoordinator.register(video);
      }
      if (videoObserver) videoObserver.observe(video);
    });

    syncVideos();
  }

  function init() {
    if ("IntersectionObserver" in window) {
      videoObserver = new window.IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          visibility.set(entry.target, entry.isIntersecting ? entry.intersectionRatio : 0);
        });
        syncVideos();
      }, { threshold: [0, 0.35, 0.5, 0.75, 1] });
    }

    registerVideos(document);

    if ("MutationObserver" in window) {
      var mutationObserver = new window.MutationObserver(function (records) {
        records.forEach(function (record) {
          record.addedNodes.forEach(function (node) {
            if (node.nodeType === 1) registerVideos(node);
          });
        });
      });
      mutationObserver.observe(document.body, { childList: true, subtree: true });
    }

    document.addEventListener("visibilitychange", syncVideos);
    [mobileViewport, coarsePointer, reducedMotion].forEach(function (mediaQuery) {
      if (typeof mediaQuery.addEventListener === "function") {
        mediaQuery.addEventListener("change", syncVideos);
      } else if (typeof mediaQuery.addListener === "function") {
        mediaQuery.addListener(syncVideos);
      }
    });
    if (connection && typeof connection.addEventListener === "function") {
      connection.addEventListener("change", syncVideos);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})(window, document);
